
import CardPropertyTable from '../../components/Card/CardPropertyTable.vue'
import VehiclePropertyCostHistoryEditor from './VehiclePropertyCostHistoryEditor.vue'
import { updateRecords } from './VehiclePropertyCostHistory.js'

export default {
  name: 'VehiclePropertyCostHistory',
  extends: CardPropertyTable,
  data: function () {
    let componentProps = this.tabProp.componentProps
    if (!componentProps) {
      componentProps = {}
      this.$set(this.tabProp, 'componentProps', componentProps)
      this.$set(this.tabProp, 'componentProps', componentProps)
      this.$set(this.tabProp, 'componentProps', componentProps)
    }

    if (componentProps.rowsPerPage == null) {
      this.$set(componentProps, 'rowsPerPage', 0)
    }
    if (componentProps.hideBottom == null) {
      this.$set(componentProps, 'hideBottom', true)
    }

    return {
      addFn: () => this.onShowObjectCard(null) // @Override
    }
  },
  computed: {
    columns: function () {
      const columnsProps = [
        { name: 'value', label: 'Цена', type: 'double', sortable: false },
        { name: 'fromDate', label: 'Действует с', type: 'date', sortable: false }
        // { name: 'toDate', label: 'Действует до', type: 'date', sortable: false }
      ]
      return columnsProps.map(o => this.getColumnConfig(o))
    },
    rows: function () {
      if (this.object && this.tabProp) {
        const value = this.object[this.tabProp.key]
        if (value == null) {
          // !!! Преобразование вынесено в ObjectCard.setObject()
          // value = []
          // this.$set(this.object, this.tabProp.key, value)
          throw new Error(`Значение табличного параметра "${this.tabProp.key}" равно null`)
        }
        return this.getRowsFiltered()
      }
      return []
    }
  },
  // created: function () {
  //   this.tabProp.editable = this.$d_hasOperation('changeEmployeeSkills', true)
  // },
  methods: {
    // @Override
    onRowClick: function ($event, row) {
      // this.$d_showObjectCard(row.id, row.type, $event.ctrlKey)
      this.onShowObjectCard(row)
    },

    // @Override
    onDeleteRow: function (row) {
      const costRecords = this.getRowsFiltered()
      const index = costRecords.indexOf(row)

      if (index > 0 && index < costRecords.length - 1) {
        // Проверяем соседние записи на идентичность значений
        const costRecordPast = costRecords[index + 1]
        const costRecordFuture = costRecords[index - 1]
        if (costRecordPast.value === costRecordFuture.value) {
          // Возможно, нужно удалить еще и будущую запись
          this.$d_ask({
            callback: (data, action) => {
              if (action === 'yes') {
                costRecords.splice(index - 1, 2)
                updateRecords(costRecords, true)
              }
              // else if (action === 'no') {
              //   costRecords.splice(index, 1)
              //   updateRecords(costRecords, true)
              // }
            },
            warning: [
              'Соседние записи содержат одинаковое значение, равное "' + costRecordPast.value + '".',
              'Эти записи будут объединены.'
              // 'Объединить записи?'
            ],
            buttons: {
              yes: 'Продолжить',
              // yes: 'Да',
              // no: 'Нет',
              cancel: 'Отмена'
            }
          })
          return
        }
      }

      costRecords.splice(index, 1)
      updateRecords(costRecords, true)
    },

    // @Override
    isRowReadonly: function (row) {
      // TODO ?
      return false
    },

    // @Override
    getTrStyle: function (row) {
      const index = this.getRowsFiltered().findIndex(r => r.id === row.id)
      if (index % 2 !== 0) {
        return 'background-color: #EDF6FF'
      } else {
        return ''
      }
    },

    getRowsFiltered: function () {
      return this.object[this.tabProp.key] // TODO ?
    },

    onShowObjectCard: function (record) {
      const records = this.object[this.tabProp.key]

      this.$d.dialog(this).show({
        maximized: false,
        persistent: true,
        headerLabel: record ? 'Запись истории цены' : 'Добавление записи истории цены',
        contentComponent: VehiclePropertyCostHistoryEditor,
        contentProps: {
          record: record || null,
          records: records,
          readonly: !this.tabProp.editable
        }
      })
    }
  }
}
